import { Grid, SxProps } from '@mui/material';

export const DpSEOSection = ({
	children,
	...props
}: {
	children: React.ReactNode;
	sx?: SxProps;
}) => (
	<Grid item xs={12} md={6} {...props}>
		{children}
	</Grid>
);
